module.exports = __webpack_public_path__ + "95557c99b28be3c50a6aecc13734118f.svg";